exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.modal-window-component[data-v-3916119e]{position:fixed;background-color:rgba(0,0,0,.8);z-index:9999;top:0;left:0;right:0;bottom:0}div.modal-window-component>div[data-v-3916119e]{width:300px;margin:0 auto;top:200px;background-color:#fff;padding:4px 0}div.modal-window-component>div>div[data-v-3916119e]{padding:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3916119e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/editors/ModalWindow.vue
// module id = 641
// module chunks = 0